import { connect } from 'react-redux'

import { updateIssue, deleteIssue, loadIssuesForLocation } from '../../actions/issues'

import IssueCardOptions from '../../components/issues/issue-card-options'
import { loadLocationIssuesCount } from '../../actions/auth'
import { fetchLocation } from '../../actions/locations'

function mapStateToProps (state, ownProps) {
  const issue = state.issues[ownProps.issueId]

  return { issue }
}

function mapDispatchToProps (dispatch, ownProps) {
  return {
    onDelete () {
      dispatch(deleteIssue(ownProps.issueId, ownProps.locationId)).
        then(() => {
          dispatch(loadLocationIssuesCount());
          dispatch(fetchLocation(ownProps.locationId))
          .then(() => dispatch(loadIssuesForLocation(ownProps.locationId)))
        })
        
    },

    onMarkAsPermanent () {
      dispatch(updateIssue(ownProps.issueId, { status: 'permanent' })).
        then(() => dispatch(loadLocationIssuesCount()))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(IssueCardOptions)



// WEBPACK FOOTER //
// ./src/containers/issues/issue-card-options-container.js